import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },

  fileNameParagrapher: {
    marginBottom: "0.5rem",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "24px",
    color: colors.black,
  },

  fileNameSpan: {
    fontWeight: 600,
  },

  sectionErrors: {
    display: "flex",
    flexDirection: "column",
    gap: "0.4rem",
    flexWrap: "wrap",
    marginBottom: "1rem",
    fontFamily: "Inter",
    fontStyle: "italic",
    fontWeight: 400,
    fontSize: "1rem",
    color: colors.warning500,
  },

  suggestionDownload: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    color: colors.black,
  },

  suggestionDownloadLink: {
    textDecoration: "underline",
    color: colors.blue500,
    "&:hover": {
      textDecoration: "underline",
      color: colors.blue500,
    },
  },
}));

export default styles;
